
import uiBottom from '@/component/uiBottom'
import uiRadio from '@/component/uiRadio'
import uiDate from '@/component/uiDate'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { getUserInfo, isApp, getDeviceInfo } from '@/util/const'

export default {
components: {
uiBottom,
uiRadio,
Datetime,
Group,
uiDate
},
data () {
return {
loading: false,
question: {
type: 3,
sex: 0,
replyType: 2
},
rules: {
userNameReg: [{
rule: /^\s*$/,
tips: this.$t('question.tips')
}],
userPhoneReg: [
{
rule: /^\s*$/,
tips: this.$t('question.tips')
}, {
flag: true,
rule: /^[456789]\d{7}$/,
tips: this.$t('question.question19')
}
],
emailReg: [{
rule: /^\s*$/,
tips: this.$t('question.tips')
}, {
flag: true,
rule: /^.+@.+$/,
tips: this.$t('question.question20')
}, {
rule: /[\u4e00-\u9fa5]/,
tips: this.$t('question.question20')
}],
nullReg: [{
rule: /^\s*$/,
tips: this.$t('question.tips')
}]
},
typeList1: [],
typeList2: [],
typeList3: [],
userInfo: null,
phoneError: false,
emailError: false
}
},
created () {
window.getUserInfo = (obj) => {
this.userInfo = obj
this.initUser()
this.getList()
}
window.getDeviceInfo = (obj) => {
Object.assign(this.question, obj)
console.log('deviceInfo:' + JSON.stringify(obj))
}
if (isApp()) {
getDeviceInfo({ callbackName: 'getDeviceInfo' })
}
},
mounted () {
if (isApp()) {
getUserInfo({ callbackName: 'getUserInfo', needLogin: false })
} else {
this.getList()
}
},
watch: {
'question.mail': function () {
this.emailError = false
},
'question.phone': function () {
this.phoneError = false
}
},
methods: {
jump () {
this.loading = true
this.phoneError = false
this.emailError = false
if (this.$valid()) {
let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
this.question.content = this.question.content.replace(regStr, '')
if (this.question.startTime) {
this.question.netTime = `${this.question.startTime},${this.question.endTime}`
}
this.$http.post(`/v1/api/user/userFeedback/none/create`, { body: this.question }).then(res => {
this.loading = false
if (res.data.body.result.isSuccess) {
this.$confirm({
title: this.$t('question.notice'),
content: this.$t('question.question51'),
buttonText: [
{
id: 'ok',
text: this.$t('question.question52')
}
]
}).then(() => {
location.href = 'cmcchkh5action://close'
})
} else if (res.data.body.result.code === 1) {
this.phoneError = true
} else if (res.data.body.result.code === 2) {
this.emailError = true
}
})
} else {
this.loading = false
}
},
getList () {
let param = {
'body': [{
'type': 3,
'subtype': 1
}, {
'type': 4,
'subtype': 2
}, {
'type': 4,
'subtype': 3
}]
}
this.$http.post(`/v1/api/user/userFeedback/none/optionLists`, param).then(res => {
let data = res.data.body.result
for (let i = 0; i < data.length; i++) {
if (data[i].type === 3 && data[i].subtype === 1) {
this.typeList1 = data[i].optionList
} else if (data[i].type === 4 && data[i].subtype === 2) {
this.typeList2 = data[i].optionList
} else if (data[i].type === 4 && data[i].subtype === 3) {
this.typeList3 = data[i].optionList
}
}
})
},
initUser () {
if (this.userInfo && this.userInfo.user) {
this.$set(this.question, 'sex', this.userInfo.user.sex)
this.$set(this.question, 'phone', this.userInfo.user.phone)
this.$set(this.question, 'mail', this.userInfo.user.email)
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/solution/index.vue